import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface Particle {
  id: number;
  x: number;
  y: number;
  angle: number;
}

export default function ParticleEffect() {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    const particleCount = 8; // Match the number of circuit lines
    const radius = 45; // Match the gear size
    const centerX = 0; // Center the particles in the middle
    const centerY = 0; // Center the particles in the middle

    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      x: centerX + Math.cos((i * 360 / particleCount) * Math.PI / 180) * radius,
      y: centerY + Math.sin((i * 360 / particleCount) * Math.PI / 180) * radius,
      angle: (i * 360 / particleCount),
    }));
    setParticles(newParticles);
  }, []);

  return (
    <svg className="absolute inset-0 w-full h-full pointer-events-none">
      <defs>
        <filter id="particle-glow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      {/* Translate to the exact center of the gear visually */}
      <g transform="translate(150 150)">
        {particles.map((particle, index) => (
          <motion.circle
            key={particle.id}
            cx={particle.x}
            cy={particle.y}
            r="2"
            fill="#60A5FA"
            filter="url(#particle-glow)"
            initial={{ opacity: 0 }}
            animate={{
              opacity: [0, 1, 0],
              scale: [0, 1.5, 0],
              cx: [particle.x, particle.x * 1.2],
              cy: [particle.y, particle.y * 1.2],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: index * 0.25, // Synchronized with circuit lines
              ease: "linear",
            }}
          />
        ))}
      </g>
    </svg>
  );
}